import ValidatorEngine from 'validatorjs'
export default class Language {
	constructor (langCode, langList) {
		this.langcode = langCode
		this.setLangList(langList)
	}

	setLangList (langList) {
		let standartList = ValidatorEngine.getMessages(this.langcode)
		if (typeof langList !== 'undefined') {
			[...Object.getOwnPropertyNames(langList)].forEach(function (val, idx, array) {
				standartList[val] = langList[val]
			})
		}

		this.langlist = standartList
	}

	getLangList () {
		return this.langlist
	}
}



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/validation/Language.js